export default "__VITE_ASSET__ColcnH80__"